export default {"src":"/_next/static/media/copy-link-active-icon.6c975de8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};